var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlphabeticalSorting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3368 3.89209C43.3033 3.89209 44.0868 4.67559 44.0868 5.64209V51.7254C44.0868 52.6919 43.3033 53.4754 42.3368 53.4754C41.3703 53.4754 40.5868 52.6919 40.5868 51.7254V5.64209C40.5868 4.67559 41.3703 3.89209 42.3368 3.89209Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50347 35.3921C7.53697 35.3921 6.75347 34.6086 6.75347 33.6421C6.75347 32.6756 7.53697 31.8921 8.50347 31.8921H27.1701C27.8779 31.8921 28.5161 32.3185 28.7869 32.9724C29.0578 33.6263 28.9081 34.379 28.4076 34.8795L12.7283 50.5588H27.1701C28.1366 50.5588 28.9201 51.3423 28.9201 52.3088C28.9201 53.2753 28.1366 54.0588 27.1701 54.0588H8.50347C7.79566 54.0588 7.15755 53.6324 6.88668 52.9785C6.61581 52.3245 6.76554 51.5718 7.26603 51.0713L22.9453 35.3921H8.50347Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1831 3.89226C18.846 3.9014 19.4468 4.2843 19.735 4.88128L28.7464 23.548C29.1666 24.4183 28.8016 25.4645 27.9313 25.8847C27.0609 26.3049 26.0147 25.9399 25.5945 25.0696L18.105 9.55558L10.0582 25.1128C9.61413 25.9712 8.55825 26.3072 7.69979 25.8631C6.84133 25.4191 6.50537 24.3632 6.9494 23.5048L16.6046 4.8381C16.9092 4.24929 17.5203 3.88311 18.1831 3.89226Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.766 41.738C32.4494 41.0546 33.5574 41.0546 34.2409 41.738L42.3368 49.8339L50.4326 41.738C51.1161 41.0546 52.2241 41.0546 52.9075 41.738C53.5909 42.4214 53.5909 43.5294 52.9075 44.2129L43.5742 53.5462C42.8908 54.2296 41.7827 54.2296 41.0993 53.5462L31.766 44.2129C31.0826 43.5294 31.0826 42.4214 31.766 41.738Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlphabeticalSorting);
export default __webpack_public_path__ + "static/media/alphabetical-sorting.36db263b.svg";
export { ForwardRef as ReactComponent };